import { render } from "./ReturnPolicy_MizukiLin.vue?vue&type=template&id=4898527b"
import script from "./ReturnPolicy_MizukiLin.vue?vue&type=script&lang=js"
export * from "./ReturnPolicy_MizukiLin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__